<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="customFilters.group"
          :items="groups"
          label="노선"
          hide-details
          clearable
          outlined></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="customFilters.plateNo"
          label="차량번호"
          hide-details
          clearable
          outlined></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
      :items="items"
      :loading="loading"
      :headers="headers"
      :search="search"
      :custom-filter="customFilter"
      class="text-no-wrap">
      <template v-slot:item.fueltype="{ item }">
        <fueltype-chip :fueltype="item.fueltype"></fueltype-chip>
      </template>
      <template v-slot:item._id="{ item }">
        {{ item._id | dateFormat }}
      </template>
      <template v-slot:item._dvh="{ item }">
        {{ item._dvh | dateFormat }}
      </template>
      <template v-slot:item._s="{ item }">
        {{ item._s | dateFormat }}
      </template>
      <template v-slot:item.edit="{ item }">
        <v-btn icon :to="getEditPath(item._id)"><v-icon>mdi-cog</v-icon></v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { getDeviceList } from '@/api'
import get from 'lodash/get'
import moment from 'moment'

export default {
  data () {
    return {
      devices: [],
      customFilters: {
        plateNo: '',
        group: ''
      },
      headers: [
        {
          text: '노선',
          value: 'group.name'
        },
        {
          text: '차량번호',
          value: 'plateNo'
        },
        {
          text: '차대번호',
          value: 'vin'
        },
        {
          text: '사업자번호',
          value: 'companyNo'
        },
        {
          text: '유종',
          value: 'fueltype'
        },
        {
          text: '모뎀번호',
          value: 'modemNo'
        },
        {
          text: '최초 등록일',
          value: '_id'
        },
        {
          text: '최종 수신일',
          value: '_dvh'
        },
        {
          text: '최종 유효 데이터 수신일',
          value: '_s'
        },
        {
          text: '편집',
          value: 'edit'
        }
      ],
      loading: false
    }
  },
  computed: {
    search () {
      return JSON.stringify(this.customFilters)
    },
    groups () {
      return Object.entries(
        this.items.reduce((groups, device) => {
          if (!groups[device.group._id]) groups[device.group._id] = device.group.name

          return groups
        }, {})
      )
        .map(([_id, name]) => {
          return {
            text: name,
            value: _id
          }
        })
    },
    items () {
      return this.devices.map(device => {
        const group = {
          name: get(device, 'group.name', '미지정'),
          _id: get(device, 'group._id', null)
        }
        const plateNo = get(device, 'info.plateNo', '미지정')
        const vin = get(device, 'info.vin', '미지정')
        const companyNo = get(device, 'info.companyNo', '미지정')
        const modemNo = device.mn
        return {
          _id: device._id,
          _dvh: device._dvh,
          _s: device._s,
          fueltype: device.fuelType,
          group,
          plateNo,
          modemNo,
          isInfo: device.isInfo,
          setISG: device.setISG,
          vin,
          companyNo
        }
      })
    }
  },
  created () {
    this.fetchDevices()
  },
  filters: {
    dateFormat (objectId) {
      if (!objectId) return ''

      return moment(new Date(parseInt(objectId.substring(0, 8), 16) * 1000)).format('YY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    async fetchDevices () {
      this.loading = true
      try {
        const query = {
          populate: 'group'
        }
        const { devices } = await getDeviceList(null, query)

        this.devices = devices
      } catch (err) {
        console.error(err)
      }
      this.loading = false
    },
    getEditPath (_id) {
      return `/settings/vehicles/edit/${_id}`
    },
    customFilter (value, search, item) {
      const { group = '', plateNo = '' } = JSON.parse(search)

      return value &&
      typeof value === 'string' &&
      (!group || item.group._id === group) &&
      (!plateNo || item.plateNo.indexOf(plateNo) !== -1)
    }
  }
}
</script>
